import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'DateToNgb',
    standalone: false
})
export class DateToNgbPipe implements PipeTransform {

  transform(value: string, ...args: any[]): { year: number, month: number, day: number} {
    if (value) {
      const date = new Date(value);
      return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    }
    return null; // or return a default value
  }
}
